import {extendTailwindMerge} from "tailwind-merge"

export const twMerge = extendTailwindMerge({
  classGroups: {
    typography: [
      "typo-title-1",
      "typo-title-2",
      "typo-body-1",
      "typo-body-2",
      "typo-button",
      "typo-text-button",
      "typo-subtitle",
      "typo-v3-header-bold-1",
      "typo-v3-header-extrabold-1",
      "typo-v3-header-extrabold-2",
      "typo-v3-button",
      "typo-v3-tag",
      "typo-v3-content-bold-1",
      "typo-v3-content-bold-2",
      "typo-v3-content-regular-1",
    ],
  },
})
